import React, { FC } from 'react'
import styled from 'styled-components'

import { MediaGalleryInterface } from '../../../../graphql/magento'
import ItemImagePreview from './ItemImagePreview'

export interface ItemImagePreviewsProps {
  className?: string
  images: (MediaGalleryInterface | null | undefined)[]
  selectedImage: MediaGalleryInterface | null | undefined
  setSelectedImage: (image: MediaGalleryInterface | null | undefined) => void
  showItemImagePreviews: boolean
}

const ItemImagePreviews: FC<ItemImagePreviewsProps> = ({
  className,
  images = [],
  selectedImage,
  setSelectedImage,
  showItemImagePreviews,
}) => {
  const onImageSelected = (url: string) => {
    setSelectedImage(images.find((image) => image?.url === url))
  }

  if (showItemImagePreviews) {
    return (
      <div className={className}>
        {images.map(
          (itemImage, index) =>
            itemImage &&
            itemImage.url && (
              <ItemImagePreview
                alt={itemImage.label ?? ''}
                className="item-image-preview"
                key={itemImage.url + index}
                selected={itemImage.url === selectedImage?.url}
                src={itemImage.url}
                onImageSelected={onImageSelected}
              />
            ),
        )}
      </div>
    )
  }

  return null
}

const StyledItemImagePreviews = styled(ItemImagePreviews)(({ theme }) => ({
  background: theme.colors.grayscale.white,
  display: 'flex',
  flexShrink: 0,
  justifyContent: 'center',
  paddingTop: '8px',
  '@media(min-width: 600px)': {
    alignSelf: 'flex-start',
    background: 'transparent',
    flex: '0 0 45px',
    flexDirection: 'column',
    marginRight: '16px',
    marginTop: '80px',
    paddingTop: '0',
  },
  '@media(min-width: 960px)': {
    marginTop: '160px',
  },
}))

export default StyledItemImagePreviews
